import React from 'react';
import { Admin, Resource, type ResourceOptions, LoginWithEmail } from "react-admin";
import { i18nProvider } from '../../i18nProvider';

// Soluciones Energéticas
import SolucionEnergeticaList from './solucion-energetica/SolucionEnergeticaList';
import SolucionEnergeticaCreate from './solucion-energetica/SolucionEnergeticaCreate';
import SolucionEnergeticaEdit from './solucion-energetica/SolucionEnergeticaEdit';

// Imagenes Inicio
import ImagenesInicioList from './imagenes-inicio/ImagenesInicioList';
import ImagenesInicioCreate from './imagenes-inicio/ImagenesInicioCreate';
import ImagenesInicioEdit from './imagenes-inicio/ImagenesInicioEdit';

// Industrias
import IndustriaList from './industria/IndustriaList';
import IndustriaCreate from './industria/IndustriaCreate';
import IndustriaEdit from './industria/IndustriaEdit';

// Exponentes Podcast
import ExponentePodcastList from './exponente-podcast/ExponentePodcastList';
import ExponentePodcastCreate from './exponente-podcast/ExponentePodcastCreate';
import ExponentePodcastEdit from './exponente-podcast/ExponentePodcastEdit';

// Casos de Éxito
import CasosExitoList from './casos-exito/CasosExitoList';
import CasosExitoCreate from './casos-exito/CasosExitoCreate';
import CasosExitoEdit from './casos-exito/CasosExitoEdit';

// Podcasts
import PodcastList from './podcast/PodcastList';
import PodcastCreate from './podcast/PodcastCreate';
import PodcastEdit from './podcast/PodcastEdit';

// Articulos
import ArticuloList from './articulo/ArticuloList';

// Iconos
import BurstModeIcon from '@mui/icons-material/BurstMode';
import GasMeterIcon from '@mui/icons-material/GasMeter';
import FactoryIcon from '@mui/icons-material/Factory';
import InterpreterModeIcon from '@mui/icons-material/InterpreterMode';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import PodcastsIcon from '@mui/icons-material/Podcasts';
import ArticleIcon from '@mui/icons-material/Article';
import ArticuloCreate from './articulo/ArticuloCreate';
import ArticuloEdit from './articulo/ArticuloEdit';

import { customDataProvider, customAuthProvider } from '../../config/services/strapi/provider';

function App() {

  return (
    <Admin
      basename='/admin'
      dataProvider={customDataProvider}
      authProvider={customAuthProvider}
      loginPage={LoginWithEmail}
      i18nProvider={i18nProvider}
    >
      <Resource
        name="imagenes-inicios"
        list={ImagenesInicioList}
        create={ImagenesInicioCreate}
        edit={ImagenesInicioEdit}
        options={{
          label: 'Imágenes de Inicio',
        } as ResourceOptions}
        icon={BurstModeIcon}
      />
      <Resource
        name="solucion-energeticas"
        list={SolucionEnergeticaList}
        create={SolucionEnergeticaCreate}
        edit={SolucionEnergeticaEdit}
        options={{
          label: 'Soluciones Energéticas',
        } as ResourceOptions}
        icon={GasMeterIcon}
      />
      <Resource
        name='industries'
        list={IndustriaList}
        create={IndustriaCreate}
        edit={IndustriaEdit}
        options={{
          label: 'Industrias',
        } as ResourceOptions}
        icon={FactoryIcon}
      />
      <Resource
        name='casos-exitos'
        list={CasosExitoList}
        create={CasosExitoCreate}
        edit={CasosExitoEdit}
        options={{
          label: 'Casos de Éxito',
        } as ResourceOptions}
        icon={EmojiEventsIcon}
      />
      <Resource
        name='exponentes-podcasts'
        list={ExponentePodcastList}
        create={ExponentePodcastCreate}
        edit={ExponentePodcastEdit}
        options={{
          label: 'Exponentes Podcast',
        } as ResourceOptions}
        icon={InterpreterModeIcon}
      />
      <Resource
        name='podcasts'
        list={PodcastList}
        create={PodcastCreate}
        edit={PodcastEdit}
        options={{
          label: 'Podcasts',
        } as ResourceOptions}
        icon={PodcastsIcon}
      />
      <Resource
        name='articulos'
        list={ArticuloList}
        create={ArticuloCreate}
        edit={ArticuloEdit}
        options={{
          label: 'Artículos',
        } as ResourceOptions}
        icon={ArticleIcon}
      />
    </Admin>
  );
}

export default App;